module.exports = __webpack_public_path__ + "img/stage1_large.eeea8898.png";